import { createPortal } from "react-dom";

const DropdownPortal = ({ children }) => {
  return createPortal(children, document.getElementById("portal-root"));
};

export default DropdownPortal;
